import { GasInstallationUnavailableMessageUI } from "./GasInstallationUnavailableMessageUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { isSupplierDirect } from "../../utils/product/isSupplierDirect";
import { getAttributeValuesFromHierarchy } from "../../utils/product/getAttributeValuesFromHierarchy";

export function GasInstallationUnavailableMessage({
  product,
}: Pick<StandardProps, "product">) {
  const { variant } = useVariant(product);
  const fuelTypeValue = getAttributeValuesFromHierarchy(
    "fueltype",
    product.attributes ?? [],
    variant.attributes ?? [],
  )[0];
  const isGasFuelType = ["gas", "lpg", "dual"].includes(
    // @ts-ignore
    fuelTypeValue?.toLowerCase(),
  );
  const isAvailableToOrder = variant.availability?.availableToOrder ?? false;
  const isValidSellingProductType = ["Cookers", "Ovens", "Hobs"].includes(
    product.sellingProductType ?? "",
  );

  const shouldDisplay =
    isGasFuelType &&
    isAvailableToOrder &&
    isValidSellingProductType &&
    !isSupplierDirect(product);

  return shouldDisplay ? <GasInstallationUnavailableMessageUI /> : null;
}
